import React from 'react';
import { useNavigate } from 'react-router-dom';
import FeaturedSolutions, { AgilysysLogo } from '../components/FeaturedSolutions';

const A = '/assets/casino/solutions/';
const BOOK4TIME_LOGO = A + 'Book4Time.svg';

const solutions = [
  { name: 'Spa',       path: 'spa',       screenshot: A + 'pc-appointments.png' },
  { name: 'Book',      path: 'book',      screenshot: A + 'app-massage-spa.png' },
  { name: 'Book4Time', path: 'book4time', screenshot: A + 'app-book4time.png',  isBook4Time: true },
  { name: 'Retail',    path: 'retail',    screenshot: A + 'pc-retail.png' },
];

function Spa() {
  const navigate = useNavigate();
  return (
    <div className="page spaPage">
      <div className="page-header">Spa</div>
      <div className="text-blocks">
        <div className="std-text">Manage all your spa operations — from scheduling services to managing staff — with a single solution that connects effortlessly to your PMS. Improve the therapist experience, simplify client engagement, and our Spa booking wizard delivers a frictionless appointment process providing visibility to service price, duration, comments, setup time, breakdown time, and priority status.{"\n\n"}</div>
        <div className="std-text">Our guestsense.ai-enabled solution helps optimize revenue and provides a conversational AI Concierge to fully automate the entire reservation flow in a natural conversation.</div>
      </div>
      <FeaturedSolutions>
        {solutions.map((sol) => (
          <div key={sol.path} className="featured-item" onClick={() => navigate(`/solutions/${sol.path}`)}>
            <img src={sol.screenshot} alt={sol.name} />
            <div className="item-head">
              {sol.isBook4Time
                ? <img className="featured-logo" src={BOOK4TIME_LOGO} alt="" />
                : <><AgilysysLogo />{sol.name}</>
              }
            </div>
          </div>
        ))}
      </FeaturedSolutions>
    </div>
  );
}

export default Spa;
